import { ButtonHTMLAttributes, ReactNode } from 'react';
import { tv } from 'tailwind-variants';

import Text from '../base/Text';

// TODO: I believe the overlay variant is not used anywhere after adjustable timeline goes live. We should remove it.
const button = tv({
  base: 'focus-visible relative inline-flex h-[30px] min-w-[30px] items-center gap-1 rounded-lg px-[5px] text-center transition-all duration-200 ease-in-out hover:no-underline',
  variants: {
    variant: {
      default:
        'bg-gray-15/25 text-gray-90 dark:bg-gray-90/25 dark:text-gray-15',
      overlay: 'dark:text-gray-90 bg-transparent',
    },
    active: {
      true: '',
      false: '',
    },
    disabled: {
      true: 'cursor-not-allowed opacity-50',
      false: '',
    },
  },
  compoundVariants: [
    // Hover styles:
    {
      variant: ['default', 'overlay'],
      active: false,
      disabled: false,
      className:
        'hover:bg-gray-15 dark:hover:bg-gray-90 dark:hover:text-gray-15 cursor-pointer active:scale-[0.98]',
    },
    // Active styles:
    {
      variant: 'default',
      active: true,
      className: 'dark:bg-gray-90 bg-white',
    },
    {
      variant: 'overlay',
      active: true,
      className: 'dark:bg-gray-90 dark:text-gray-15 bg-white',
    },
  ],
  defaultVariants: {
    variant: 'default',
    active: false,
  },
});

export default function ToggleButton({
  variant = 'default',
  icon,
  text,
  active = false,
  disabled = false,
  className,
  ...props
}: {
  variant?: 'default' | 'overlay';
  icon?: ReactNode;
  text?: ReactNode | string;
  active?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  const hasIcon = Boolean(icon);

  return (
    <button
      className={button({
        variant,
        active,
        disabled,
        className: `${hasIcon ? '' : 'justify-center'} ${className ?? ''}`.trim(),
      })}
      {...props}
    >
      {icon && <span className="w-[20px] flex-none">{icon}</span>}
      {text &&
        (typeof text === 'string' ? (
          <Text
            variant="studio/body/medium/xs"
            className={`${hasIcon ? '' : 'w-full text-center'} truncate pt-[0.15em] lg:block`.trim()}
          >
            {text}
          </Text>
        ) : (
          <>{text}</>
        ))}
    </button>
  );
}
